import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full px-6 py-5 md:py-6 max-w-5xl mx-auto" data-id="element-24">
      <motion.div className="text-center mb-5" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-25">
        <p className="text-xl md:text-2xl text-[#3D3D3D] leading-relaxed max-w-3xl mx-auto" data-id="element-26">
          Plan Anti-Pantalla es un plan práctico de 30 días para ayudar a las
          familias a recuperar estructura y claridad en el uso de pantallas.
        </p>
      </motion.div>

      <motion.div className="text-center" initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.6
    }} data-id="element-27">
        <p className="text-[#7A7A7A] italic text-sm md:text-base" data-id="element-28">
          (Material educativo, pensado para la vida real.)
        </p>
      </motion.div>
    </section>;
}